import { FormGroup, FormControl, AbstractControl } from '@angular/forms';

import { VALIDATION_REGEXP } from 'app/shared/constants/app-service-constants';

export class FormValidator {
  static upperCase(control: FormControl) {
    const controlVal: any = control.value;
    const passed = /[A-Z]/.test(controlVal);

    return passed ? null : { upperCase: true };
  }

  static lowerCase(control: FormControl) {
    const controlVal: any = control.value;
    const passed = /[a-z]/.test(controlVal);

    return passed ? null : { lowerCase: true };
  }

  static digits(control: FormControl) {
    const controlVal: any = control.value;
    const passed = /\d/.test(controlVal);

    return passed ? null : { digits: true };
  }

  static specialSymbol(control: FormControl) {
    const controlVal: any = control.value;
    // eslint-disable-next-line no-useless-escape
    const passed = /[\[\]\\\/$&+_,:;=?@#|'"`~<>.^*()%!-]/.test(controlVal);

    return passed ? null : { specialSymbol: true };
  }

  static noWhiteSpace(control: FormControl) {
    const controlVal: any = control.value;
    const failed = VALIDATION_REGEXP.HAS_EMPTY_CHAR.test(controlVal);

    return failed ? { noWhiteSpace: true } : null;
  }

  static passwordCompare(accountFormGroup: FormGroup) {
    const password = accountFormGroup?.controls?.password?.value;
    const rePassword = accountFormGroup?.controls?.rePassword?.value;
    const passed = password && password === rePassword;

    return passed ? null : { passwordCompare: true };
  }

  static getValidClass(controlName: string, errorTypeField: string, formGroup: any): string {
    let errorType = errorTypeField;
    if (errorTypeField === 'minLength') {
      errorType = 'minlength';
    }

    if (errorTypeField === 'maxLength') {
      errorType = 'maxlength';
    }

    return this.isError(controlName, errorType, formGroup) ||
      this.isError(controlName, 'required', formGroup)
      ? 'error'
      : 'valid';
  }

  static isError(controlName: string, errorType: string, formGroup): boolean {
    const control: AbstractControl = formGroup.get(controlName);
    const controlHasError = control.hasError(errorType);

    if (errorType === 'passwordCompare') {
      const rePasswordControl: AbstractControl = formGroup.get('rePassword');
      const groupHasError = formGroup.hasError(errorType);

      return groupHasError && (rePasswordControl.dirty || rePasswordControl.touched);
    }

    if (errorType === 'emailCompare') {
      const reEmailControl: AbstractControl = formGroup.get('confirmEmailAddress');
      const groupHasError = formGroup.hasError(errorType);

      return groupHasError && (reEmailControl.dirty || reEmailControl.touched);
    }

    return controlHasError && (control.dirty || control.touched);
  }
}
